import { Component } from 'react';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import { Switch, Route, Redirect} from 'react-router-dom';
import { setSearchData } from '../../redux/actions/searchAction';
import ViewAddress from './View';
import BuildingOverview from './BuildingOverview';
import setSearchScope from '../../Helpers/setSearchScope';

class Addresses extends Component {

    componentDidMount() {
        setSearchScope('addresses');
        document.querySelector('title').innerHTML = 'MijnDP - Adressen';
    }

    _getFirstAddressWithMessages = () => {

        let addressMessages = {};

        if ( this.props.messages ) {
            if ( this.props.messages.data ) {
                if ( this.props.messages.data.data.length ) {
                    this.props.messages.data.data.forEach((item, i) => {

                        if ( item.has_been_read === '0' && item.is_priority === '1') {

                            if ( addressMessages[item.dp_address_id]) {
                              
                                addressMessages = {
                                    ...addressMessages,
                                    [item.dp_address_id] : addressMessages[item.dp_address_id] += 1
                                }
                            } else {
                                addressMessages = {
                                    ...addressMessages,
                                    [item.dp_address_id] : 1
                                }
                            }
                        }
                    });
                }
            }
        }

        let itemToReturn = false;
        let highestCount = 0;
        for( let objectID in addressMessages ) {
            if ( addressMessages.hasOwnProperty(objectID) ) {
                if ( addressMessages[objectID] >= highestCount ) {
                    itemToReturn = objectID;
                    highestCount = addressMessages[objectID];
                }
            }
        }

        if ( itemToReturn ) {
            return itemToReturn;
        } else {
            return this.props.addresses[0]['dp_address_id'];
        }


    }
    render() {
        return (
            <div>
                <BuildingOverview />
                <Switch>
                    {this.props.match.path === '/adressen' ? this.props.addresses ? this.props.addresses[0] ?  <Redirect to={"/adressen/bekijken/" + this._getFirstAddressWithMessages()} /> : null : null : null}
                    <Route
                        path='/adressen/bekijken/:id'
                        render={ (props) =>
                                <ViewAddress />
                        }/>
                    }
                </Switch>
            </div>
        );
    }
}

function mapStateToProps(state) {
  return {
    addresses: state.AddressReducer.addresses,
    searchData: state.SearchDataReducer,
    messages: state.messagesReducer.messages,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
        updateSearchData: (data) => dispatch(setSearchData(data))
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Addresses));



// WEBPACK FOOTER //
// ./src/components/Addresses/index.js